import { useEffect, useRef, useState } from "react";
import RightModal from "../../../components/Modal/RightModal";
import SavedFilterComponent from "../../../components/SavedFilters/SavedFilterComponent";
import { initialClosedFilterData } from "../../../utils/initialData";
import { countNonMatchingEntries, handleDropdownClose } from "../../../utils/utils";
import ClosedFilterData from "../../Closed/components/ClosedFilterData";




const ClosedArchiveFilter = ({ filterData, onSetFilterData, onCallApiAgain, from }) => {
    const dropdownRef = useRef(null);
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [selectedSavefilterId, setSelectedSaveFilterId] = useState(() => {
        const id = localStorage.getItem("selectedSavefilterId");
        return id ? id : "";
    });

    const count = countNonMatchingEntries(filterData, initialClosedFilterData);

    useEffect(() => {
        const handleClose = () => {
            setIsSidebarOpen(false);
        };
        handleDropdownClose(dropdownRef, handleClose);
    }, []);

    const handleFilter = () => {
        localStorage.setItem("filterData", JSON.stringify(filterData));
        onCallApiAgain();
        setIsSidebarOpen(false);
        setSelectedSaveFilterId("");
    };

    const handleFilterChange = (value, name) => {
        onSetFilterData({ ...filterData, [name]: value });
    };

    const handleSelectFilter = (value) => {
        const dataToSet = {
            count: value?.count ?? "",
            start_count: value?.start_count ?? "",
            end_count: value?.end_count ?? "",
        };
        localStorage.setItem("filterData", JSON.stringify(dataToSet));
        onSetFilterData(dataToSet);
        onCallApiAgain(dataToSet);
    };

    const saveSearchFilterData = {
        count: filterData?.count ?? "",
        start_count: filterData?.start_count ?? "",
        end_count: filterData?.end_count ?? "",

    };

    return (
        <div>
            <SavedFilterComponent
                from={from}
                count={count}
                isSidebarOpen={isSidebarOpen}
                saveSearchFilterData={saveSearchFilterData}
                selectedSavefilterId={selectedSavefilterId}
                initialFilterData={initialClosedFilterData}
                onCallApiAgain={onCallApiAgain}
                onSetFilterData={onSetFilterData}
                onSetSelectedSaveFilterId={(value) => {
                    setSelectedSaveFilterId(value);
                }}
                handleSelectFilter={handleSelectFilter}
                onSetIsSidebarOpen={(value) => setIsSidebarOpen(value)}
            />

            <RightModal
                isOpen={isSidebarOpen}
                onClose={() => {
                    setIsSidebarOpen(false);
                    onSetFilterData(initialClosedFilterData);
                }}
                ref={dropdownRef}
                title={"Filter"}
                from={from}
                desc={`Enter ${from} information.`}
                onFilter={handleFilter}
                saveSearchFilterData={saveSearchFilterData}
                onSetSelectedSaveFilterId={(value) => setSelectedSaveFilterId(value)}
            >
                <ClosedFilterData isSidebarOpen={isSidebarOpen} filterData={filterData} handleFilterChange={handleFilterChange} onSetFilterData={onSetFilterData} from="closedarchive" />
            </RightModal>
        </div>
    );
};

export default ClosedArchiveFilter;
